export default "__VITE_ASSET__DMBES0oD__"